import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './style.css';

class Button extends Component {
  static propTypes = {
    className: PropTypes.string,
    type: PropTypes.string,
    label: PropTypes.string,
    primary: PropTypes.bool,
    disabled: PropTypes.bool,
    icon: PropTypes.string
  };
  static defaultProps = {
    className: '',
    type: 'button',
    label: undefined,
    icon: undefined,
    primary: false,
    disabled: false,
    invert: false
  };
  render() {
    const {
      className,
      type,
      primary,
      disabled,
      label,
      icon,
      invert,
      ...rest
    } = this.props;
    const classList = classNames('button', className, {
      'button-primary': primary,
      'button-invert': invert
    });
    return (
      <button className={classList} type={type} disabled={disabled} {...rest}>
        {icon && <i className={`button-icon fas fa-${icon}`} />}
        {label && <span className="button-label">{label}</span>}
      </button>
    );
  }
}

export default Button;
